import Decimal from 'decimal.js';
import { sendErrReport } from "../infra/utils";
import { getAccountingDetails } from "../integrations/Accounting/accounting.utils";
import { Accounting } from "../types/api.model";
import { MoneyModel } from "./MoneyModel";
import { ServiceCostType } from "./service-cost/model";
import { serviceBillingModel, serviceCostModel } from '.';
export let ActivityLogEntryType = /*#__PURE__*/function (ActivityLogEntryType) {
  ActivityLogEntryType["Relationship"] = "relationship";
  ActivityLogEntryType["Charge"] = "charge";
  ActivityLogEntryType["Invoice"] = "invoice";
  ActivityLogEntryType["Service"] = "service";
  ActivityLogEntryType["Business"] = "business";
  return ActivityLogEntryType;
}({});
export let ActivityLogAgreementState = /*#__PURE__*/function (ActivityLogAgreementState) {
  ActivityLogAgreementState["Sent"] = "sent";
  ActivityLogAgreementState["Reviewed"] = "reviewed";
  ActivityLogAgreementState["MicroDepositStarted"] = "microDepositStarted";
  ActivityLogAgreementState["MicroDepositStartedV2"] = "microDepositStartedV2";
  ActivityLogAgreementState["MicroDeposit"] = "microDeposit";
  ActivityLogAgreementState["MicroDepositFailed"] = "microDepositFailed";
  ActivityLogAgreementState["MicroDepositFailedV2"] = "microDepositFailedV2";
  ActivityLogAgreementState["MicroDepositVerified"] = "microDepositVerified";
  ActivityLogAgreementState["MicroDepositVerifiedV2"] = "microDepositVerifiedV2";
  ActivityLogAgreementState["PaymentMethod"] = "paymentMethod";
  ActivityLogAgreementState["Approved"] = "approved";
  ActivityLogAgreementState["Terminated"] = "terminated";
  ActivityLogAgreementState["Changed"] = "changed";
  ActivityLogAgreementState["ChangesApproved"] = "changesApproved";
  ActivityLogAgreementState["ChangesAutoApproved"] = "changesAutoApproved";
  ActivityLogAgreementState["StoppedAutoApproval"] = "stoppedAutoApproval";
  ActivityLogAgreementState["SigningReminderSent"] = "signingReminderSent";
  ActivityLogAgreementState["SigningReminderSentManual"] = "signingReminderSentManual";
  ActivityLogAgreementState["MicroDepositReminderSent"] = "microDepositReminderSent";
  ActivityLogAgreementState["PaymentMethodChanged"] = "paymentMethodChanged";
  ActivityLogAgreementState["SignedExternally"] = "signedExternally";
  ActivityLogAgreementState["RequestedPaymentMethod"] = "requestedPaymentMethod";
  ActivityLogAgreementState["LegalTermsUpdated"] = "legalTermsUpdated";
  ActivityLogAgreementState["AmendmentsApprovalMethodUpdated"] = "amendmentsApprovalMethodUpdated";
  ActivityLogAgreementState["InvoicesApprovalMethodUpdated"] = "invoicesApprovalMethodUpdated";
  ActivityLogAgreementState["TitleUpdated"] = "titleUpdated";
  ActivityLogAgreementState["ManualPaymentsUpdated"] = "manualPaymentsUpdated";
  ActivityLogAgreementState["CoverCreditCardFeesUpdated"] = "coverCreditCardFeesUpdated";
  ActivityLogAgreementState["SellerUpdated"] = "sellerUpdated";
  ActivityLogAgreementState["PracticeManagementContactCreated"] = "practiceManagementContactCreated";
  ActivityLogAgreementState["PracticeManagementItemsCreated"] = "practiceManagementItemsCreated";
  ActivityLogAgreementState["PaymentMethodDisconnected"] = "paymentMethodDisconnected";
  ActivityLogAgreementState["SentSilently"] = "sentSilently";
  ActivityLogAgreementState["MicroDepositRestarted"] = "microDepositRestarted";
  ActivityLogAgreementState["AmendmentApprovalReminderSent"] = "amendmentApprovalReminderSent";
  return ActivityLogAgreementState;
}({});
export let ActivityLogChannel = /*#__PURE__*/function (ActivityLogChannel) {
  ActivityLogChannel["Email"] = "email";
  ActivityLogChannel["Sms"] = "sms";
  return ActivityLogChannel;
}({});
export let ActivityLogChargeState = /*#__PURE__*/function (ActivityLogChargeState) {
  ActivityLogChargeState["Created"] = "created";
  ActivityLogChargeState["Canceled"] = "canceled";
  ActivityLogChargeState["Approved"] = "approved";
  return ActivityLogChargeState;
}({});
export let ActivityLogInvoiceState = /*#__PURE__*/function (ActivityLogInvoiceState) {
  ActivityLogInvoiceState["AccountingInvoiceResyncRequested"] = "accountingInvoiceResyncRequested";
  ActivityLogInvoiceState["AccountingInvoiceSynced"] = "accountingInvoiceSynced";
  ActivityLogInvoiceState["AccountingPaymentSynced"] = "accountingPaymentSynced";
  ActivityLogInvoiceState["Voided"] = "voided";
  ActivityLogInvoiceState["Unvoided"] = "unvoided";
  ActivityLogInvoiceState["Completed"] = "completed";
  ActivityLogInvoiceState["IssuedIncomplete"] = "issuedIncomplete";
  ActivityLogInvoiceState["Issued"] = "issued";
  ActivityLogInvoiceState["PaymentFailed"] = "paymentFailed";
  ActivityLogInvoiceState["PaymentRetried"] = "paymentRetried";
  ActivityLogInvoiceState["PaymentRetriedByAdmin"] = "paymentRetriedByAdmin";
  ActivityLogInvoiceState["PaymentAutoRetried"] = "paymentAutoRetried";
  ActivityLogInvoiceState["PaymentRetriedByCustomer"] = "paymentRetriedByCustomer";
  ActivityLogInvoiceState["PaymentRetriedByVendor"] = "paymentRetriedByVendor";
  ActivityLogInvoiceState["Paid"] = "paid";
  ActivityLogInvoiceState["PaidExternally"] = "paidExternally";
  ActivityLogInvoiceState["DisputeResolved"] = "disputeResolved";
  ActivityLogInvoiceState["Approved"] = "approved";
  ActivityLogInvoiceState["Resent"] = "resent";
  ActivityLogInvoiceState["PaymentConfirmed"] = "paymentConfirmed";
  ActivityLogInvoiceState["PaymentProcessing"] = "paymentProcessing";
  ActivityLogInvoiceState["InvoiceIntegrationCreated"] = "invoiceIntegrationCreated";
  ActivityLogInvoiceState["InvoiceIntegrationSyncFailed"] = "invoiceIntegrationSyncFailed";
  ActivityLogInvoiceState["InvoiceIntegrationPaymentCreated"] = "invoiceIntegrationPaymentCreated";
  ActivityLogInvoiceState["InvoiceIntegrationPaymentSyncFailed"] = "invoiceIntegrationPaymentSyncFailed";
  ActivityLogInvoiceState["InvoiceIntegrationVoided"] = "invoiceIntegrationVoided";
  ActivityLogInvoiceState["Refunded"] = "refunded";
  ActivityLogInvoiceState["PaymentStoppedOLD"] = "disputed";
  ActivityLogInvoiceState["PaymentStopped"] = "paymentStopped";
  ActivityLogInvoiceState["PaymentResumed"] = "paymentResumed";
  ActivityLogInvoiceState["PaymentDisputed"] = "paymentDisputed";
  ActivityLogInvoiceState["RefundRequested"] = "refundRequested";
  ActivityLogInvoiceState["PaymentAutoApproved"] = "paymentAutoApproved";
  ActivityLogInvoiceState["AutoApprovalDisabled"] = "autoApprovalDisabled";
  ActivityLogInvoiceState["PayNowRequested"] = "payNowRequested";
  ActivityLogInvoiceState["RefundFailed"] = "refundFailed";
  ActivityLogInvoiceState["InvoiceSanctionFound"] = "invoiceSanctionFound";
  ActivityLogInvoiceState["UnmarkedAsPaidExternally"] = "unmarkedAsPaidExternally";
  return ActivityLogInvoiceState;
}({});
export let ActivityLogServiceState = /*#__PURE__*/function (ActivityLogServiceState) {
  ActivityLogServiceState["Created"] = "created";
  ActivityLogServiceState["Changed"] = "changed";
  ActivityLogServiceState["Approved"] = "approved";
  ActivityLogServiceState["AutoApproved"] = "autoApproved";
  ActivityLogServiceState["ChangesApproved"] = "changesApproved";
  ActivityLogServiceState["ChangesAutoApproved"] = "changesAutoApproved";
  ActivityLogServiceState["Paused"] = "paused";
  ActivityLogServiceState["Resumed"] = "resumed";
  ActivityLogServiceState["Terminated"] = "terminated";
  ActivityLogServiceState["Canceled"] = "canceled";
  ActivityLogServiceState["BillCommandDeliverablesPendingApproval"] = "billCommandDeliverablesPendingApproval";
  ActivityLogServiceState["BillCommandDeliverablesApproved"] = "billCommandDeliverablesApproved";
  ActivityLogServiceState["BillCommandDeliverablesRejected"] = "billCommandDeliverablesRejected";
  ActivityLogServiceState["BillCommandDeliverablesWithdrawn"] = "billCommandDeliverablesWithdrawn";
  ActivityLogServiceState["ChangesDiscarded"] = "changesDiscarded";
  ActivityLogServiceState["PriceIncreased"] = "autoPriceIncreased";
  ActivityLogServiceState["IntegratedClassChanged"] = "integratedClassChanged";
  ActivityLogServiceState["ServiceDiscountExpired"] = "serviceDiscountExpired";
  return ActivityLogServiceState;
}({});
export let ActivityLogBusinessState = /*#__PURE__*/function (ActivityLogBusinessState) {
  ActivityLogBusinessState["BusinessNameChanged"] = "businessNameChanged";
  ActivityLogBusinessState["CustomerNameChangedBySeller"] = "customerNameChangedBySeller";
  ActivityLogBusinessState["TeamMemberAdded"] = "teamMemberAdded";
  ActivityLogBusinessState["TeamMemberAddedBySeller"] = "teamMemberAddedBySeller";
  ActivityLogBusinessState["TeamMemberRemoved"] = "teamMemberRemoved";
  ActivityLogBusinessState["TeamMemberRemovedBySeller"] = "teamMemberRemovedBySeller";
  ActivityLogBusinessState["TeamMemberRoleChanged"] = "teamMemberRoleChanged";
  ActivityLogBusinessState["TeamMemberRoleChangedBySeller"] = "teamMemberRoleChangedBySeller";
  ActivityLogBusinessState["CustomerBusinessCreated"] = "customerBusinessCreated";
  return ActivityLogBusinessState;
}({});
export let ActivityLogPaymentMethodType = /*#__PURE__*/function (ActivityLogPaymentMethodType) {
  ActivityLogPaymentMethodType["MultiAch"] = "multiAch";
  ActivityLogPaymentMethodType["Ach"] = "ach";
  ActivityLogPaymentMethodType["CreditCard"] = "creditCard";
  return ActivityLogPaymentMethodType;
}({});
export let ActivityLogBusinessDataType = /*#__PURE__*/function (ActivityLogBusinessDataType) {
  ActivityLogBusinessDataType["BusinessNameChanged"] = "businessNameChanged";
  ActivityLogBusinessDataType["CustomerNameChangedBySeller"] = "customerNameChangedBySeller";
  ActivityLogBusinessDataType["TeamMemberAdded"] = "teamMemberAdded";
  ActivityLogBusinessDataType["TeamMemberAddedBySeller"] = "teamMemberAddedBySeller";
  ActivityLogBusinessDataType["TeamMemberRemoved"] = "teamMemberRemoved";
  ActivityLogBusinessDataType["TeamMemberRemovedBySeller"] = "teamMemberRemovedBySeller";
  ActivityLogBusinessDataType["TeamMemberRoleChanged"] = "teamMemberRoleChanged";
  ActivityLogBusinessDataType["TeamMemberRoleChangedBySeller"] = "teamMemberRoleChangedBySeller";
  ActivityLogBusinessDataType["CustomerBusinessCreated"] = "customerBusinessCreated";
  return ActivityLogBusinessDataType;
}({});
export let ActivityLogPMIntegrationName = /*#__PURE__*/function (ActivityLogPMIntegrationName) {
  ActivityLogPMIntegrationName["Karbon"] = "karbon";
  ActivityLogPMIntegrationName["ClientHub"] = "client-hub";
  ActivityLogPMIntegrationName["FinancialCents"] = "financial-cents";
  ActivityLogPMIntegrationName["Keeper"] = "keeper";
  return ActivityLogPMIntegrationName;
}({});
export let AccountingIntegrationType = /*#__PURE__*/function (AccountingIntegrationType) {
  AccountingIntegrationType["QBO"] = "qbo";
  AccountingIntegrationType["Xero"] = "xero";
  return AccountingIntegrationType;
}({});
export class ActivityLogEntryModel {
  static make(dto) {
    switch (dto.type) {
      case ActivityLogEntryType.Relationship:
        return new ActivityLogAgreementEntryModel(dto);
      case ActivityLogEntryType.Charge:
        return new ActivityLogChargeEntryModel(dto);
      case ActivityLogEntryType.Invoice:
        return new ActivityLogInvoiceEntryModel(dto);
      case ActivityLogEntryType.Service:
        return new ActivityLogServiceEntryModel(dto);
      case ActivityLogEntryType.Business:
        return ActivityLogBusinessEntryModel.make(dto);
    }
  }
  constructor(dto) {
    this.dto = dto;
    this.timestampAsDate = new Date(this.dto.timestamp);
  }
  isAgreementEntry() {
    return this.dto.type === ActivityLogEntryType.Relationship;
  }
  isServiceEntry() {
    return this.dto.type === ActivityLogEntryType.Service;
  }
  isChargeEntry() {
    return this.dto.type === ActivityLogEntryType.Charge;
  }
  isInvoiceEntry() {
    return this.dto.type === ActivityLogEntryType.Invoice;
  }
  isBusinessEntry() {
    return this.dto.type === ActivityLogEntryType.Business;
  }
  id() {
    return this.dto.id;
  }
  state() {
    return this.dto.state;
  }
  timestamp() {
    return this.timestampAsDate;
  }
  accept(visitor) {
    if (this.isAgreementEntry()) {
      return visitor.whenAgreement(this);
    } else if (this.isChargeEntry()) {
      return visitor.whenCharge(this);
    } else if (this.isInvoiceEntry()) {
      return visitor.whenInvoice(this);
    } else if (this.isServiceEntry()) {
      return visitor.whenService(this);
    } else if (this.isBusinessEntry()) {
      return visitor.whenBusiness(this);
    } else {
      const err = new Error("Unknown entry type ".concat(this.dto.type));
      sendErrReport(err);
      throw err;
    }
  }
  nameAndEmail(name, email) {
    return name ? email ? "".concat(name, " (").concat(email, ")") : name : '';
  }
}
export class ActivityLogAgreementEntryModel extends ActivityLogEntryModel {
  constructor(dto) {
    super(dto);
    this.agreementDTO = dto;
  }
  state() {
    return this.agreementDTO.state;
  }
  vendorName() {
    var _this$agreementDTO$da;
    return (_this$agreementDTO$da = this.agreementDTO.data.vendor) === null || _this$agreementDTO$da === void 0 ? void 0 : _this$agreementDTO$da.name;
  }
  customerName() {
    var _this$agreementDTO$da2;
    return (_this$agreementDTO$da2 = this.agreementDTO.data.customer) === null || _this$agreementDTO$da2 === void 0 ? void 0 : _this$agreementDTO$da2.name;
  }
  customer() {
    return this.agreementDTO.data.customer;
  }
  vendor() {
    return this.agreementDTO.data.vendor;
  }
  customerNameAndEmail() {
    const customer = this.customer();
    return customer ? this.nameAndEmail(customer.name, customer.email) : '';
  }
  isReminderEntry() {
    return [ActivityLogAgreementState.SigningReminderSent, ActivityLogAgreementState.SigningReminderSentManual, ActivityLogAgreementState.MicroDepositReminderSent].includes(this.agreementDTO.state);
  }
  channel() {
    return this.agreementDTO.data.channel;
  }
  paymentMethod() {
    return this.agreementDTO.data.paymentMethod;
  }
  hasReviewers() {
    const reviewers = this.reviewers();
    return !!reviewers && reviewers.length > 0;
  }
  reviewerNamesAndEmails() {
    const reviewers = this.reviewers();
    return (reviewers || []).map(r => this.nameAndEmail(r.name, r.email));
  }
  netTermsChanges() {
    var _this$agreementDTO$da3;
    return (_this$agreementDTO$da3 = this.agreementDTO.data.changes) === null || _this$agreementDTO$da3 === void 0 ? void 0 : _this$agreementDTO$da3.netTerms;
  }
  amendmentsApprovalMethodChanges() {
    var _this$agreementDTO$da4;
    return (_this$agreementDTO$da4 = this.agreementDTO.data.changes) === null || _this$agreementDTO$da4 === void 0 ? void 0 : _this$agreementDTO$da4.amendmentsApprovalMethod;
  }
  invoicesApprovalMethodChanges() {
    var _this$agreementDTO$da5;
    return (_this$agreementDTO$da5 = this.agreementDTO.data.changes) === null || _this$agreementDTO$da5 === void 0 ? void 0 : _this$agreementDTO$da5.invoicesApprovalMethod;
  }
  titleChanges() {
    var _this$agreementDTO$da6;
    return (_this$agreementDTO$da6 = this.agreementDTO.data.changes) === null || _this$agreementDTO$da6 === void 0 ? void 0 : _this$agreementDTO$da6.title;
  }
  manualPaymentsChanges() {
    var _this$agreementDTO$da7;
    return (_this$agreementDTO$da7 = this.agreementDTO.data.changes) === null || _this$agreementDTO$da7 === void 0 ? void 0 : _this$agreementDTO$da7.manualPayments;
  }
  coverCCFeesChanges() {
    var _this$agreementDTO$da8;
    return (_this$agreementDTO$da8 = this.agreementDTO.data.changes) === null || _this$agreementDTO$da8 === void 0 ? void 0 : _this$agreementDTO$da8.coverCreditCardFees;
  }
  sellerChanges() {
    var _this$agreementDTO$da9;
    return (_this$agreementDTO$da9 = this.agreementDTO.data.changes) === null || _this$agreementDTO$da9 === void 0 ? void 0 : _this$agreementDTO$da9.seller;
  }
  integrationName() {
    return this.agreementDTO.data.integrationName;
  }
  integrationServices() {
    return this.agreementDTO.data.integrationServices;
  }
  reviewers() {
    return this.agreementDTO.data.reviewers;
  }
}
export class ActivityLogServiceEntryModel extends ActivityLogEntryModel {
  constructor(dto) {
    super(dto);
    this.serviceDTO = dto;
    const serviceChanges = dto.data.service.changes;
    if (serviceChanges !== null && serviceChanges !== void 0 && serviceChanges.cost) {
      this._serviceChangesCost = serviceCostModel.fromDTO(serviceChanges.cost);
    }
    if (serviceChanges !== null && serviceChanges !== void 0 && serviceChanges.billing) {
      this._serviceChangesBilling = serviceBillingModel.fromDTO(serviceChanges.billing) || undefined;
    }
    const serviceBeforeChanges = dto.data.service.beforeChanges;
    if (serviceBeforeChanges !== null && serviceBeforeChanges !== void 0 && serviceBeforeChanges.cost) {
      this._serviceBeforeChangesCost = serviceCostModel.fromDTO(serviceBeforeChanges.cost);
    }
  }
  vendorName() {
    var _this$serviceDTO$data;
    return (_this$serviceDTO$data = this.serviceDTO.data.vendor) === null || _this$serviceDTO$data === void 0 ? void 0 : _this$serviceDTO$data.name;
  }
  customerName() {
    var _this$serviceDTO$data2;
    return (_this$serviceDTO$data2 = this.serviceDTO.data.customer) === null || _this$serviceDTO$data2 === void 0 ? void 0 : _this$serviceDTO$data2.name;
  }
  customer() {
    return this.serviceDTO.data.customer;
  }
  vendor() {
    return this.serviceDTO.data.vendor;
  }
  hasChanges() {
    return !!this.serviceDTO.data.service.changes;
  }
  descriptionChange() {
    var _this$serviceDTO$data3;
    return (_this$serviceDTO$data3 = this.serviceDTO.data.service.changes) === null || _this$serviceDTO$data3 === void 0 ? void 0 : _this$serviceDTO$data3.description;
  }
  serviceChangesCost() {
    return this._serviceChangesCost;
  }
  priceChange() {
    const cost = this.serviceChangesCost();
    if (!(cost !== null && cost !== void 0 && cost.pricingType)) return null;
    switch (cost.pricingType) {
      case ServiceCostType.Fixed:
      case ServiceCostType.Variable:
        return cost.price;
      case ServiceCostType.Range:
        return cost.maxPrice;
    }
  }
  priceBeforeChange() {
    var _this$_serviceBeforeC;
    if (!((_this$_serviceBeforeC = this._serviceBeforeChangesCost) !== null && _this$_serviceBeforeC !== void 0 && _this$_serviceBeforeC.pricingType)) return null;
    switch (this._serviceBeforeChangesCost.pricingType) {
      case ServiceCostType.Fixed:
      case ServiceCostType.Variable:
        return this._serviceBeforeChangesCost.price;
      case ServiceCostType.Range:
        return this._serviceBeforeChangesCost.maxPrice;
    }
  }
  integratedClassNameChange() {
    var _this$serviceDTO$data4;
    return ((_this$serviceDTO$data4 = this.serviceDTO.data.service.changes) === null || _this$serviceDTO$data4 === void 0 || (_this$serviceDTO$data4 = _this$serviceDTO$data4.integratedClass) === null || _this$serviceDTO$data4 === void 0 ? void 0 : _this$serviceDTO$data4.name) || null;
  }
  integratedClassNameBeforeChange() {
    var _this$serviceDTO$data5;
    return ((_this$serviceDTO$data5 = this.serviceDTO.data.service.beforeChanges) === null || _this$serviceDTO$data5 === void 0 || (_this$serviceDTO$data5 = _this$serviceDTO$data5.integratedClass) === null || _this$serviceDTO$data5 === void 0 ? void 0 : _this$serviceDTO$data5.name) || null;
  }
  billingChange() {
    return this._serviceChangesBilling;
  }
  note() {
    return this.serviceDTO.data.service.note;
  }
  name() {
    return this.serviceDTO.data.service.name;
  }
  isDiscountExpirationEntry() {
    return this.state() === ActivityLogServiceState.ServiceDiscountExpired;
  }
}
export class ActivityLogChargeEntryModel extends ActivityLogEntryModel {
  constructor(dto) {
    super(dto);
    this.chargeDTO = dto;
    this.price = MoneyModel.fromDTO(dto.data.charge.temp_price);
  }
  vendorName() {
    var _this$chargeDTO$data$;
    return (_this$chargeDTO$data$ = this.chargeDTO.data.vendor) === null || _this$chargeDTO$data$ === void 0 ? void 0 : _this$chargeDTO$data$.name;
  }
  customerName() {
    var _this$chargeDTO$data$2;
    return (_this$chargeDTO$data$2 = this.chargeDTO.data.customer) === null || _this$chargeDTO$data$2 === void 0 ? void 0 : _this$chargeDTO$data$2.name;
  }
  customer() {
    return this.chargeDTO.data.customer;
  }
  vendor() {
    return this.chargeDTO.data.vendor;
  }
  name() {
    return this.chargeDTO.data.charge.name;
  }
  note() {
    return this.chargeDTO.data.charge.note;
  }
  formattedPrice() {
    return this.price.display();
  }
}
export class ActivityLogInvoiceEntryModel extends ActivityLogEntryModel {
  constructor(dto) {
    super(dto);
    this.invoiceDTO = dto;
    this.totalAmountAsMoney = MoneyModel.fromDTO(dto.data.invoice.totalAmount);
  }
  vendorName() {
    var _this$invoiceDTO$data;
    return (_this$invoiceDTO$data = this.invoiceDTO.data.vendor) === null || _this$invoiceDTO$data === void 0 ? void 0 : _this$invoiceDTO$data.name;
  }
  customerName() {
    var _this$invoiceDTO$data2;
    return (_this$invoiceDTO$data2 = this.invoiceDTO.data.customer) === null || _this$invoiceDTO$data2 === void 0 ? void 0 : _this$invoiceDTO$data2.name;
  }
  customer() {
    return this.invoiceDTO.data.customer;
  }
  vendor() {
    return this.invoiceDTO.data.vendor;
  }
  invoiceId() {
    return this.invoiceDTO.data.invoice.id;
  }
  integrationFullName() {
    const integrationType = this.integrationType();
    return integrationType && getAccountingDetails(integrationType).fullName;
  }
  integrationType() {
    const accountingType = {
      [AccountingIntegrationType.QBO]: Accounting.QBO,
      [AccountingIntegrationType.Xero]: Accounting.Xero
    };
    return this.invoiceDTO.data.integrationName ? accountingType[this.invoiceDTO.data.integrationName] : undefined;
  }
  formattedNumber() {
    return this.invoiceDTO.data.invoice.formattedNumber;
  }
  totalAmount() {
    return this.totalAmountAsMoney;
  }
  paymentStoppedReason() {
    var _this$invoiceDTO$data3;
    return (_this$invoiceDTO$data3 = this.invoiceDTO.data.paymentStopped) === null || _this$invoiceDTO$data3 === void 0 ? void 0 : _this$invoiceDTO$data3.reason;
  }
  refundRequestedReason() {
    var _this$invoiceDTO$data4, _this$invoiceDTO$data5;
    return ((_this$invoiceDTO$data4 = this.invoiceDTO.data.refundRequested) === null || _this$invoiceDTO$data4 === void 0 ? void 0 : _this$invoiceDTO$data4.reason) || ((_this$invoiceDTO$data5 = this.invoiceDTO.data.refunded) === null || _this$invoiceDTO$data5 === void 0 ? void 0 : _this$invoiceDTO$data5.reason);
  }
  totalRefundedAmount() {
    var _this$invoiceDTO$data6;
    return new MoneyModel(new Decimal(((_this$invoiceDTO$data6 = this.invoiceDTO.data.refunded) === null || _this$invoiceDTO$data6 === void 0 || (_this$invoiceDTO$data6 = _this$invoiceDTO$data6.amounts) === null || _this$invoiceDTO$data6 === void 0 ? void 0 : _this$invoiceDTO$data6.totalRefundedAmount) || 0).div(100));
  }
  haveFees() {
    var _this$invoiceDTO$data7;
    return ((_this$invoiceDTO$data7 = this.invoiceDTO.data.refunded) === null || _this$invoiceDTO$data7 === void 0 || (_this$invoiceDTO$data7 = _this$invoiceDTO$data7.amounts) === null || _this$invoiceDTO$data7 === void 0 ? void 0 : _this$invoiceDTO$data7.refundedFeesAmount) || 0 > 0;
  }
  isFullRefund() {
    var _this$invoiceDTO$data8;
    // before partial refund was introduced, we had a single refund amount which we took from the invoice total amount
    if (!((_this$invoiceDTO$data8 = this.invoiceDTO.data.refunded) !== null && _this$invoiceDTO$data8 !== void 0 && _this$invoiceDTO$data8.amounts)) return true;
    return new Decimal(this.invoiceDTO.data.refunded.amounts.refundedAmount).div(100).eq(this.totalAmount().amount());
  }
}
export class ActivityLogBusinessEntryModel extends ActivityLogEntryModel {
  static make(dto) {
    switch (dto.data.type) {
      case ActivityLogBusinessDataType.BusinessNameChanged:
        return new ActivityLogBusinessNameChangedEntryModel(dto);
      case ActivityLogBusinessDataType.CustomerNameChangedBySeller:
        return new ActivityLogCustomerNameChangedBySellerEntryModel(dto);
      case ActivityLogBusinessDataType.TeamMemberAdded:
        return new ActivityLogTeamMemberAddedEntryModel(dto);
      case ActivityLogBusinessDataType.TeamMemberAddedBySeller:
        return new ActivityLogTeamMemberAddedBySellerEntryModel(dto);
      case ActivityLogBusinessDataType.TeamMemberRemoved:
        return new ActivityLogTeamMemberRemovedEntryModel(dto);
      case ActivityLogBusinessDataType.TeamMemberRemovedBySeller:
        return new ActivityLogTeamMemberRemovedBySellerEntryModel(dto);
      case ActivityLogBusinessDataType.TeamMemberRoleChanged:
        return new ActivityLogTeamMemberRoleChangedEntryModel(dto);
      case ActivityLogBusinessDataType.TeamMemberRoleChangedBySeller:
        return new ActivityLogTeamMemberRoleChangedBySellerEntryModel(dto);
      case ActivityLogBusinessDataType.CustomerBusinessCreated:
        return new ActivityLogCustomerBusinessCreatedEntryModel(dto);
    }
  }
  constructor(dto) {
    super(dto);
    this.businessDTO = dto;
  }
  state() {
    return this.businessDTO.state;
  }
  businessData() {
    return this.businessDTO.data;
  }
  businessId() {
    return this.businessDTO.data.value.businessId;
  }
  isBusinessNameChanged() {
    return this.businessDTO.data.type === ActivityLogBusinessDataType.BusinessNameChanged || this.businessDTO.data.type === ActivityLogBusinessDataType.CustomerNameChangedBySeller;
  }
  isTeamMemberAdded() {
    return this.businessDTO.data.type === ActivityLogBusinessDataType.TeamMemberAdded || this.businessDTO.data.type === ActivityLogBusinessDataType.TeamMemberAddedBySeller;
  }
  isCustomerBusinessCreated() {
    return this.businessDTO.data.type === ActivityLogBusinessDataType.CustomerBusinessCreated;
  }
  isBusinessNameChangedEntry() {
    return this.businessDTO.data.type === ActivityLogBusinessDataType.BusinessNameChanged;
  }
  isCustomerNameChangedBySellerEntry() {
    return this.businessDTO.data.type === ActivityLogBusinessDataType.CustomerNameChangedBySeller;
  }
  isTeamMemberAddedEntry() {
    return this.businessDTO.data.type === ActivityLogBusinessDataType.TeamMemberAdded;
  }
  isTeamMemberAddedBySellerEntry() {
    return this.businessDTO.data.type === ActivityLogBusinessDataType.TeamMemberAddedBySeller;
  }
  isTeamMemberRemovedEntry() {
    return this.businessDTO.data.type === ActivityLogBusinessDataType.TeamMemberRemoved;
  }
  isTeamMemberRemovedBySellerEntry() {
    return this.businessDTO.data.type === ActivityLogBusinessDataType.TeamMemberRemovedBySeller;
  }
  isTeamMemberRoleChangedEntry() {
    return this.businessDTO.data.type === ActivityLogBusinessDataType.TeamMemberRoleChanged;
  }
  isTeamMemberRoleChangedBySellerEntry() {
    return this.businessDTO.data.type === ActivityLogBusinessDataType.TeamMemberRoleChangedBySeller;
  }
  isCustomerBusinessCreatedEntry() {
    return this.businessDTO.data.type === ActivityLogBusinessDataType.CustomerBusinessCreated;
  }
  acceptBusinessEntry(visitor) {
    if (this.isBusinessNameChangedEntry()) {
      return visitor.whenBusinessNameChanged(this);
    } else if (this.isCustomerNameChangedBySellerEntry()) {
      return visitor.whenCustomerNameChangedBySeller(this);
    } else if (this.isTeamMemberAddedEntry()) {
      return visitor.whenTeamMemberAdded(this);
    } else if (this.isTeamMemberAddedBySellerEntry()) {
      return visitor.whenTeamMemberAddedBySeller(this);
    } else if (this.isTeamMemberRemovedEntry()) {
      return visitor.whenTeamMemberRemoved(this);
    } else if (this.isTeamMemberRemovedBySellerEntry()) {
      return visitor.whenTeamMemberRemovedBySeller(this);
    } else if (this.isTeamMemberRoleChangedEntry()) {
      return visitor.whenTeamMemberRoleChanged(this);
    } else if (this.isTeamMemberRoleChangedBySellerEntry()) {
      return visitor.whenTeamMemberRoleChangedBySeller(this);
    } else if (this.isCustomerBusinessCreatedEntry()) {
      return visitor.whenCustomerBusinessCreated(this);
    } else {
      const err = new Error("Unknown business entry type ".concat(this.businessDTO.data.type));
      sendErrReport(err);
      throw err;
    }
  }
}
export class ActivityLogBusinessNameChangedEntryModel extends ActivityLogBusinessEntryModel {
  get data() {
    return this.businessDTO.data;
  }
  updatedByName() {
    return this.data.value.updatedBy.userName;
  }
  updatedByEmail() {
    return this.data.value.updatedBy.userEmail;
  }
  oldName() {
    return this.data.value.oldName;
  }
  newName() {
    return this.data.value.newName;
  }
  updatedBy() {
    return this.data.value.updatedBy;
  }
}

// Child class for CustomerNameChangedBySeller
export class ActivityLogCustomerNameChangedBySellerEntryModel extends ActivityLogBusinessEntryModel {
  get data() {
    return this.businessDTO.data;
  }
  oldName() {
    return this.data.value.oldName;
  }
  updatedByName() {
    return this.data.value.updatedBy.userName;
  }
  updatedByEmail() {
    return this.data.value.updatedBy.userEmail;
  }
  newName() {
    return this.data.value.newName;
  }
  vendorName() {
    return this.data.value.vendorName;
  }
  updatedBy() {
    return this.data.value.updatedBy;
  }
}
export class ActivityLogTeamMemberAddedEntryModel extends ActivityLogBusinessEntryModel {
  get data() {
    return this.businessDTO.data;
  }
  updatedByName() {
    return this.data.value.updatedBy.userName;
  }
  updatedByEmail() {
    return this.data.value.updatedBy.userEmail;
  }
  addedMemberName() {
    return this.data.value.addedMemberName;
  }
  addedMemberEmail() {
    return this.data.value.addedMemberEmail;
  }
  addedMemberRole() {
    return this.data.value.addedMemberRole;
  }
  updatedBy() {
    return this.data.value.updatedBy;
  }
}
export class ActivityLogTeamMemberAddedBySellerEntryModel extends ActivityLogBusinessEntryModel {
  get data() {
    return this.businessDTO.data;
  }
  updatedByName() {
    return this.data.value.updatedBy.userName;
  }
  updatedByEmail() {
    return this.data.value.updatedBy.userEmail;
  }
  addedMemberName() {
    return this.data.value.addedMemberName;
  }
  addedMemberEmail() {
    return this.data.value.addedMemberEmail;
  }
  addedMemberRole() {
    return this.data.value.addedMemberRole;
  }
  vendorName() {
    return this.data.value.vendorName;
  }
  updatedBy() {
    return this.data.value.updatedBy;
  }
}
export class ActivityLogTeamMemberRemovedEntryModel extends ActivityLogBusinessEntryModel {
  get data() {
    return this.businessDTO.data;
  }
  updatedByName() {
    return this.data.value.updatedBy.userName;
  }
  updatedByEmail() {
    return this.data.value.updatedBy.userEmail;
  }
  removedMemberName() {
    return this.data.value.removedMemberName;
  }
  removedMemberEmail() {
    return this.data.value.removedMemberEmail;
  }
}
export class ActivityLogTeamMemberRemovedBySellerEntryModel extends ActivityLogBusinessEntryModel {
  get data() {
    return this.businessDTO.data;
  }
  updatedByName() {
    return this.data.value.updatedBy.userName;
  }
  updatedByEmail() {
    return this.data.value.updatedBy.userEmail;
  }
  removedMemberName() {
    return this.data.value.removedMemberName;
  }
  removedMemberEmail() {
    return this.data.value.removedMemberEmail;
  }
  vendorName() {
    return this.data.value.vendorName;
  }
  updatedBy() {
    return this.data.value.updatedBy;
  }
}
export class ActivityLogTeamMemberRoleChangedEntryModel extends ActivityLogBusinessEntryModel {
  get data() {
    return this.businessDTO.data;
  }
  updatedByName() {
    return this.data.value.updatedBy.userName;
  }
  updatedByEmail() {
    return this.data.value.updatedBy.userEmail;
  }
  memberName() {
    return this.data.value.memberName;
  }
  memberEmail() {
    return this.data.value.memberEmail;
  }
  oldRole() {
    return this.data.value.oldRole;
  }
  newRole() {
    return this.data.value.newRole;
  }
  updatedBy() {
    return this.data.value.updatedBy;
  }
}
export class ActivityLogTeamMemberRoleChangedBySellerEntryModel extends ActivityLogBusinessEntryModel {
  get data() {
    return this.businessDTO.data;
  }
  updatedByName() {
    return this.data.value.updatedBy.userName;
  }
  updatedByEmail() {
    return this.data.value.updatedBy.userEmail;
  }
  memberName() {
    return this.data.value.memberName;
  }
  memberEmail() {
    return this.data.value.memberEmail;
  }
  oldRole() {
    return this.data.value.oldRole;
  }
  newRole() {
    return this.data.value.newRole;
  }
  vendorName() {
    return this.data.value.vendorName;
  }
}
export class ActivityLogCustomerBusinessCreatedEntryModel extends ActivityLogBusinessEntryModel {
  get data() {
    return this.businessDTO.data;
  }
  businessName() {
    return this.data.value.businessName;
  }
  vendorId() {
    return this.data.value.vendorId;
  }
  vendorName() {
    return this.data.value.vendorName;
  }
  createdBy() {
    return this.data.value.createdBy;
  }
  createdByName() {
    return this.data.value.createdBy.userName;
  }
  createdByEmail() {
    return this.data.value.createdBy.userEmail;
  }
}